import { RouteConfig } from 'vue-router';

import AppLayout from '@/AppLayout.vue';
import store from '@/store/store';
import { getProfileId } from '@/utils/profile';
import { clubContainerRoute } from './clubContainer.route';
import { configurationContainerRoute } from './configurationContainer.route';
import { homeRoute } from './home.route';
import { myProfileRoute } from './profile/myProfile.route';
import { profileContainerRoute } from './profileContainer.route';

export const mainRoute: RouteConfig = {
  path: '/',
  component: AppLayout,
  meta: {
    authorized: true,
    menuList: true
  },
  children: [homeRoute, myProfileRoute, profileContainerRoute, clubContainerRoute, configurationContainerRoute],
  beforeEnter: (from: any, to: any, next: () => void) => {
    store.commit('profile/setId', getProfileId());

    Promise.all([store.dispatch('auth/loadData'), store.dispatch('menu/getMenu'), store.dispatch('profile/get')])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: 'messages.auth.loadDataError' }));
  }
};
